import styled from "styled-components";

export const EditorWrapper = styled.div`
  width: 27vw;
  min-width: 280px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`;

export const Toolbar = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0.4rem 0.5rem;
  border: 2px solid var(--border-default);
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  background: var(--surface-glass);
  backdrop-filter: blur(10px);
`;

export const ToolbarButton = styled.button`
  min-width: 32px;
  height: 30px;
  padding: 0 0.5rem;
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  background: ${({ $active }) =>
    $active ? "var(--accent-soft)" : "var(--surface-glass)"};
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent-soft);
    border-color: var(--accent);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EditorArea = styled.div`
  width: 100%;
  box-sizing: border-box;
  min-height: 8rem;
  max-height: 22rem;
  overflow-y: auto;
  padding: 0.8rem;
  border: 2px solid var(--border-default);
  border-radius: 0 0 12px 12px;
  background: var(--input-bg);
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.5;
  outline: none;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  text-align: left;

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  &:empty::before {
    content: attr(data-placeholder);
    color: var(--input-placeholder);
    pointer-events: none;
  }

  p {
    margin: 0 0 0.5rem;
  }

  ul,
  ol {
    margin: 0 0 0.5rem;
    padding-left: 1.4rem;
  }

  a {
    color: var(--text-heading);
  }
`;

export const EditorFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.35rem;
  font-size: 10px;
`;

export const EditorHint = styled.span`
  color: var(--text-muted);
`;

export const CharCounter = styled.span`
  color: ${({ $limitReached }) =>
    $limitReached ? "var(--danger)" : "var(--text-secondary)"};
  font-weight: ${({ $limitReached }) => ($limitReached ? 700 : 400)};
  white-space: nowrap;
`;
